<template>
  <el-form ref="form" :model="tableData" :rules="rules" label-width="150px" style="width:50%">
    <el-form-item label="一级经销商扣款比例" prop="fDistributorBl1">
      <el-input-currency v-model="tableData.fDistributorBl1" :scale="2" size="" />
    </el-form-item>
    <el-form-item label="二级经销商扣款比例" prop="fDistributorBl2">
      <el-input-currency v-model="tableData.fDistributorBl2" :scale="2" size="" />
    </el-form-item>
    <el-form-item label="三级经销商扣款比例" prop="fDistributorBl3">
      <el-input-currency v-model="tableData.fDistributorBl3" :scale="2" size="" />
    </el-form-item>
    <el-form-item label="受控号" prop="fControlledNumber">
      <el-input v-model="tableData.fControlledNumber" />
    </el-form-item>
    <el-form-item>
      <el-button v-if="canEdit" type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="onReset">重置</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  data() {
    return {
      tableData: {},
      selectOptions: [],
      selectValue: '',
      loading: false,
      selectFid: '',
      selectArr: [],
      canEdit: true,
      rules: {
        fDistributorBl1: [{ required: true, message: '必填项(数字)', trigger: 'change' }],
        fDistributorBl2: [{ required: true, message: '必填项(数字)', trigger: 'change' }],
        fDistributorBl3: [{ required: true, message: '必填项(数字)', trigger: 'change' }],
        fControlledNumber: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.refresh()
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach(val => {
      if (val.key === '004005') {
        this.canEdit = val.isGrant
      }
    })
  },
  methods: {
    // 获取快递公司列表
    refresh() {
      this.loading = true
      this.$httpPost('BasicInformation/SystemSetUp/GetSystemSetUp').then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.tableData = res.datalist
      })
        .finally(() => this.loading = false)
    },
    onReset() {
      this.refresh()
    },
    onSubmit() {
      this.$httpPost('BasicInformation/SystemSetUp/SystemSetUpSave', {
        datalist: JSON.stringify({
          ...this.tableData
        //   info
        })
      }).then(async res => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    }
  }
}
</script>
<style lang="">

</style>
